import moment, { Moment } from "moment";
import { SPORT_LISTS } from "../../contrainers/SportsBar/config";
import { Sport } from "../../types/sport";
import { DateOptions } from "./types";

export const BASKETBALL_2 = "BASKETBALL_2";
export type ResultSport = Sport | typeof BASKETBALL_2;

const sportLabels: Record<Sport, string> = {
  [Sport.FOOTBALL]: "ฟุตบอล",
  [Sport.BASKETBALL]: "บาสเก็ตบอล",
  [Sport.VOLLEYBALL]: "วอลเลย์บอล",
  [Sport.CRICKET]: "คริกเก็ต",
  [Sport.TENNIS]: "เทนนิส",
  [Sport.TABLETENNIS]: "เทเบิลเทนนิส",
  [Sport.HANDBALL]: "แฮนด์บอล",
  [Sport.ICEHOCKEY]: "ฮอกกี้น้ำแข็ง",
  [Sport.SNOOKER]: "สนุกเกอร์",
  [Sport.BASEBALL]: "เบสบอล",
  [Sport.RUGBY]: "รักบี้",
  [Sport.AMERICAN_FOOTBALL]: "อเมริกันฟุตบอล",
  [Sport.BADMINTON]: "แบดมินตัน",
  [Sport.COCK_FIGHT]: "ไก่ชน",
  [Sport.BULL_FIGHT]: "วัวชน",
  [Sport.BOXING]: "มวยไทย",
};

export const sportOptions = SPORT_LISTS.flatMap<{ label: string; value: ResultSport }>((sport) => {
  if (sport.isComingSoon || !sport.routeTo) {
    return [];
  }

  const value = (
    sport.routeTo === "americanfootball"
      ? "american_football"
      : sport.routeTo
  ).toUpperCase() as Sport;
  if (!Object.values(Sport).includes(value)) {
    return [];
  }

  const option = { label: sportLabels[value], value };
  if (value === Sport.BASKETBALL) {
    return [option, { label: "Basketball 2", value: BASKETBALL_2 }];
  }

  return [option];
});

export const getPreviousDateOptions = (date: Moment = moment()) =>
  Array.from({ length: 8 }, (_, index) => ({
    label: date.clone().subtract(index + 1, "days").format("DD/MM"),
    value: `last${index + 1}`,
  }));

export const dateTypeOptions = [
  { label: "วันนี้", value: DateOptions.TODAY },
  { label: "ย้อนหลัง 8 วัน", value: DateOptions.EIGHT_DAYS_AGO },
];

export const defaultSportOption = sportOptions[0];
export const defaultDateTypeOption = dateTypeOptions[0];

export const defaultState = {
  selectedDate: "last1",
};
